import { logWrapper } from '../utils';

export default [
  'runtimeConstant',
  '$stateProvider',
  'webApiSettings',
  function (runtimeConstant, $stateProvider, webApiSettings) {
    function run() {
      try {
        $stateProvider
          .state('modules.reports', {
            url: '/relatorios',
            templateUrl: 'views/modules/reports/base.html',
            controller: 'reportController',
            redirectTo: 'modules.reports.dashboard', //remover esse redirect quando for implementado os outros relatorios
            data: {
              title: 'Dashboard',
            },
          })
          .state('modules.reports.dashboard', {
            url: '/dashboard',
            templateUrl: 'views/modules/reports/dashboard.html',
            controller: 'dashboardController',
            data: {
              title: 'Dashboard',
            },
          })
          .state('modules.reports.expiredRevisions', {
            url: '/expiredrevisions/',
            templateUrl: 'views/modules/reports/expiredRevisions.html',
            controller: 'expiredRevisionsController',
            data: {
              title: 'Expired Revisions',
            },
          })
          .state('modules.reports.additionalFields', {
            url: '/additionalFields/',
            templateUrl: 'views/modules/reports/additionalFields.html',
            controller: 'additionalFieldsController',
            data: {
              title: 'Campos Adicionais',
            },
          })
          .state('modules.reports.inventory', {
            url: '/inventory/',
            templateUrl: 'views/modules/reports/inventory.html',
            controller: 'inventoryController',
            data: {
              title: 'Inventário',
            },
          })
          .state('modules.reports.indexedPages', {
            url: '/indexedPages/',
            templateUrl: 'views/modules/reports/indexedPages.html',
            controller: 'indexedPagesController',
            data: {
              title: 'Paginas indexadas',
            },
          })
          .state('modules.reports.auditUser', {
            url: '/auditUser/',
            templateUrl: 'views/modules/reports/auditUser.html',
            controller: 'auditUserController',
            data: {
              title: 'Auditoria do usuário',
            },
          })
          .state('modules.reports.publicLink', {
            url: '/publicLinkActive/',
            templateUrl: 'views/modules/reports/publicLink.html',
            controller: 'publicLinkReportController',
            data: {
              title: 'Links Públicos',
            },
          });

          if (webApiSettings.detailsCompany !== 'abase') {
            $stateProvider.state('modules.reports.sharedFolders', {
              url: '/sharedFoldersActive/',
              templateUrl: 'views/modules/reports/sharedFolders.html',
              controller: 'sharedFoldersReportController',
              data: {
                title: 'Pastas compartilhadas',
              },
            });
          }

          $stateProvider
          .state('modules.reports.pendingSubscription', {
            url: '/pendingSubscriptionActive/',
            templateUrl: 'views/modules/reports/pendingSubscription.html',
            controller: 'pendingSubscriptionController',
            data: {
              title: 'Assinaturas Pendentes',
            },
          })
          .state('modules.reports.activeUsers', {
            url: '/activeUsers/',
            templateUrl: 'views/modules/reports/activeUsers.html',
            controller: 'activeUsersController',
            data: {
              title: 'Usuários Ativos/Inativos',
            },
          });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    }

    // Wrap the setup function with logWrapper for debugging purposes
    logWrapper(run, runtimeConstant.isDebugConfigs)();
  },
];
